import PropTypes from 'prop-types';
import { isArray, isArrayEmpty } from '../../../utility/helpers';

const Switch = ({ condition = '', children = null }) => {
  if (!condition || !children) {
    return null;
  }

  const arrayOfChildren = isArray(children) ? children : [children];
  const cases = arrayOfChildren.filter(child => {
    const when = child?.props?.when;

    if (isArray(when)) return when.includes(condition);

    return when === condition;
  });

  return !isArrayEmpty(cases) ? <>{cases}</> : null;
};

const Case = ({ children = null }) => {
  return <>{children}</>;
};

Switch.propTypes = {
  condition: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

Case.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

export { Switch, Case };
